import { FunctionComponent, ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import CanPower from '../canPower';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFLaptop from '@/components/UI/svg/LandingPage/EFLaptop';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';
import EFTv from '@/components/UI/svg/LandingPage/EFTv';
import EFClothesDryer from '@/components/UI/svg/LandingPage/EFClothesDryer';

const { EFPic } = createEFPic('/img/landingPage');
interface PropsType {
    id: string;
}
const AdvancedKit: FunctionComponent<PropsType> = (props: PropsType) => {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const canPowerList1 = [
        {
            name: t('secG_Light'),
            times: t('secG_Light_1'),
            icon: <EFLight />,
        },
        {
            name: t('secG_WiFiRouter'),
            times: t('secG_WiFiRouter_1'),
            icon: <EFWifiRouter />,
        },
        {
            name: t('secG_TV'),
            times: t('secG_TV_1'),
            icon: <EFTv />,
        },
        {
            name: t('secG_Refrigerator'),
            times: t('secG_Refrigerator_1'),
            icon: <EFRefrigerator />,
        },
        {
            name: t('secG_Electrickettle'),
            times: t('secG_Electrickettle_1'),
            icon: <EFElectricKettle />,
        },
        {
            name: t('secG_ElectricHeater'),
            times: t('secG_ElectricHeater_1'),
            icon: <EFElectricHeater />,
        },
        {
            name: t('secG_ElectricOven'),
            times: t('secG_ElectricOven_1'),
            icon: <EFLaptop />,
        },

        {
            name: t('secG_Microwave'),
            times: t('secG_Microwave_1'),
            icon: <EFMicroware />,
        },
        {
            name: t('secG_AirConditioner'),
            times: t('secG_AirConditioner_1'),
            icon: <EFAirConditioner />,
        },
        {
            name: t('secG_ClothesDryer'),
            times: t('secG_ClothesDryer_1'),
            icon: <EFClothesDryer />,
        },
    ];
    const canPowerList2 = [
        {
            name: t('secG_Light'),
            times: t('secG_Light_2'),
            icon: <EFLight />,
        },
        {
            name: t('secG_WiFiRouter'),
            times: t('secG_WiFiRouter_2'),
            icon: <EFWifiRouter />,
        },
        {
            name: t('secG_TV'),
            times: t('secG_TV_2'),
            icon: <EFTv />,
        },
        {
            name: t('secG_Refrigerator'),
            times: t('secG_Refrigerator_2'),
            icon: <EFRefrigerator />,
        },
        {
            name: t('secG_Electrickettle'),
            times: t('secG_Electrickettle_2'),
            icon: <EFElectricKettle />,
        },
        {
            name: t('secG_ElectricHeater'),
            times: t('secG_ElectricHeater_2'),
            icon: <EFElectricHeater />,
        },
        {
            name: t('secG_ElectricOven'),
            times: t('secG_ElectricOven_2'),
            icon: <EFLaptop />,
        },

        {
            name: t('secG_Microwave'),
            times: t('secG_Microwave_2'),
            icon: <EFMicroware />,
        },
        {
            name: t('secG_AirConditioner'),
            times: t('secG_AirConditioner_2'),
            icon: <EFAirConditioner />,
        },
        {
            name: t('secG_ClothesDryer'),
            times: t('secG_ClothesDryer_2'),
            icon: <EFClothesDryer />,
        },
    ];
    const canPowerList3 = [
        {
            name: t('secG_Light'),
            times: t('secG_Light_3'),
            icon: <EFLight />,
        },
        {
            name: t('secG_WiFiRouter'),
            times: t('secG_WiFiRouter_3'),
            icon: <EFWifiRouter />,
        },
        {
            name: t('secG_TV'),
            times: t('secG_TV_3'),
            icon: <EFTv />,
        },
        {
            name: t('secG_Refrigerator'),
            times: t('secG_Refrigerator_3'),
            icon: <EFRefrigerator />,
        },
        {
            name: t('secG_Electrickettle'),
            times: t('secG_Electrickettle_3'),
            icon: <EFElectricKettle />,
        },
        {
            name: t('secG_ElectricHeater'),
            times: t('secG_ElectricHeater_3'),
            icon: <EFElectricHeater />,
        },
        {
            name: t('secG_ElectricOven'),
            times: t('secG_ElectricOven_3'),
            icon: <EFLaptop />,
        },

        {
            name: t('secG_Microwave'),
            times: t('secG_Microwave_3'),
            icon: <EFMicroware />,
        },
        {
            name: t('secG_AirConditioner'),
            times: t('secG_AirConditioner_3'),
            icon: <EFAirConditioner />,
        },
        {
            name: t('secG_ClothesDryer'),
            times: t('secG_ClothesDryer_3'),
            icon: <EFClothesDryer />,
        },
    ];
    const buyNow = (url: string, name: string) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: name,
                position: `Solution Page_${t('secE_item2_title_1')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open(url);
    };
    return (
        <div className={css.advancedKit} id={props.id}>
            <div className="content">
                <div className="swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-swiper starterkit-swiper"
                        height={326}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={true}
                        loop
                        speed={800}
                        spaceBetween={10}
                        centeredSlides={true}
                    >
                        <SwiperSlide>
                            <EFPic name={['/h5/solution/Advanced Kit.webp', '/h5/solution/Advanced Kit.jpg']} alt={t('delta_pro_whole_home.solution2_name')} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <EFPic name={['/pc/g-5.webp', '/pc/g-5.png']} alt={t('delta_pro_whole_home.solution2_name')} />
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="info-box">
                    <div className="name">{t('delta_pro_whole_home.solution2_name')}</div>
                    <div className="device">{t('delta_pro_whole_home.solution2_device')}</div>
                    <div className="power">
                        {t.rich('delta_pro_whole_home.solution2_list', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                            line3: (child: ReactNode) => <div>{child} </div>,
                            line4: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                    <div className="desc">{t('delta_pro_whole_home.solution2_desc2')}</div>
                </div>
                <div className="buy-box">
                    <div
                        className="buy-btn"
                        onClick={() => buyNow(`https://${locale}.ecoflow.com/products/delta-pro-double-voltage-hub`, t('secG_item1_title1'))}
                    >
                        {t('buy_now')}
                    </div>
                    <div className="buy-desc">{t('delta_pro_whole_home.solution2_buy_desc')}</div>
                </div>
                <div className="img-box">
                    <EFPic name={['/pc/g-5.webp', '/pc/g-5.png']} alt={t('delta_pro_whole_home.solution2_name')} />
                </div>
                <div className="info-box info-box2">
                    <div className="device">
                        {t.rich('delta_pro_whole_home.solution2_1_name', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                    <div className="power">
                        {t.rich('delta_pro_whole_home.solution2_1_device', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                            line3: (child: ReactNode) => <div>{child} </div>,
                            line4: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                </div>
                <div className="buy-box">
                    <div
                        className="buy-btn"
                        onClick={() => buyNow(`https://${locale}.ecoflow.com/products/delta-pro-double-voltage-hub`, t('secG_item1_title1'))}
                    >
                        {t('buy_now')}
                    </div>
                </div>
                <CanPower list={canPowerList1} />
                <div className="img-box">
                    <EFPic name={['/pc/g-3.webp', '/pc/g-3.png']} alt={t('delta_pro_whole_home.solution2_name')} />
                </div>
                <div className="info-box info-box2">
                    <div className="device">
                        {t.rich('delta_pro_whole_home.solution2_device2', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                    <div className="power">
                        {t.rich('delta_pro_whole_home.solution2_list2', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                            line3: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                </div>
                <div className="buy-box">
                    <div
                        className="buy-btn"
                        onClick={() =>
                            buyNow(
                                `https://${locale}.ecoflow.com/products/delta-pro-double-voltage-hub?variant=${
                                    locale === 'ca' ? '43246000767130' : '40435773866057'
                                }`,
                                t('secG_item2_title1'),
                            )
                        }
                    >
                        {t('buy_now')}
                    </div>
                </div>
                <CanPower list={canPowerList2} />
                <div className="img-box">
                    <EFPic name={['/pc/g-4.webp', '/pc/g-4.png']} alt={t('delta_pro_whole_home.solution2_name')} />
                </div>
                <div className="info-box info-box2">
                    <div className="device">
                        {t.rich('delta_pro_whole_home.solution2_device3', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                    <div className="power">
                        {t.rich('delta_pro_whole_home.solution2_list3', {
                            line1: (child: ReactNode) => <div>{child} </div>,
                            line2: (child: ReactNode) => <div>{child} </div>,
                            line3: (child: ReactNode) => <div>{child} </div>,
                        })}
                    </div>
                </div>
                <div className="buy-box">
                    <div
                        className="buy-btn"
                        onClick={() =>
                            buyNow(
                                `https://${locale}.ecoflow.com/products/delta-pro-double-voltage-hub?variant=${
                                    locale === 'ca' ? '43246000799898' : '40435774390345'
                                }`,
                                t('secG_item3_title1'),
                            )
                        }
                    >
                        {t('buy_now')}
                    </div>
                </div>
                <CanPower list={canPowerList3} />
            </div>
        </div>
    );
};

export default AdvancedKit;
